import * as z from "zod";

export const ShopifyCanonicalDomainSchema = z
  .string()
  .toLowerCase()
  .regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.myshopify\.com$/);

export const OnlineStoreHostnameSchema = z
  .string()
  .max(253)
  .toLowerCase()
  .regex(/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z](?:[a-z0-9-]{0,61}[a-z0-9])?$/);

export const ShopifyOnlineStoreDomainResponseSchema = z.object({
  errors: z
    .unknown()
    .optional()
    .refine((errors) => !errors, "Shopify domain lookup returned errors"),
  data: z.object({
    shop: z.object({
      primaryDomain: z.object({ host: OnlineStoreHostnameSchema }),
    }),
  }),
});
